<template>
  <CoreImage
    v-if="type"
    :image="asset"
    :optimiseImages="optimiseImages"
    :imgClass="mergeAssetClass"
  />
  <div v-else>
    <CoreVideo :class="mergeAssetClass" :video="asset" />
  </div>
</template>

<script>
export default {
  name: "ProjectsAsset",

  props: {
    optimiseImages: {
      type: Boolean,
      default: true
    },
    imgClass: {
      type: String,
      default: ""
    },
    asset: {
      type: Object,
      default: () => ({})
    },
    assetClass: {
      type: String,
      default: ""
    }
  },

  computed: {
    type() {
      return this.asset.fields.file.contentType === "video/mp4" ? false : true;
    },
    mergeAssetClass() {
      return `select-none h-full object-cover ${this.assetClass}`;
    }
  }
};
</script>
